<template>
  <div :class="[`h-breakpoint--${size}`]" class="h-breakpoint">
    <slot />
  </div>
</template>

<script>
import {
  on,
  off,
  width,
  height,
  isNumber,
  isUndefined,
  throttle
} from '@hui-pro/utils';

export default {
  name: 'HBreakpoint',
  props: {
    throttle: {
      type: Number,
      default: 160
    },
    breakpoint: {
      type: Object,
      default: () => {
        return {
          xs: 480,
          sm: 576,
          md: 768,
          lg: 992,
          xl: 1200,
          xxl: 1600
        };
      }
    }
  },
  data() {
    return {
      size: 'md'
    };
  },
  watch: {
    size(val) {
      this.$emit('on-change', val);
    }
  },
  created() {
    this.throttleResize = throttle(() => {
      this.resize();
    }, this.throttle);
  },
  mounted() {
    on(this.$el, 'resize', this.throttleResize);
    this.resize();
  },
  beforeDestroy() {
    off(this.$el, 'resize', this.throttleResize);
  },
  methods: {
    resize() {
      this.$nextTick(() => {
        const elWidth = width(this.$el);
        const elHeight = height(this.$el);
        const breakpoint = this.breakpoint;
        // xs
        if (isNumber(breakpoint.xs) && elWidth >= breakpoint.xs) {
          this.size = 'xs';
        } else if (
          !isUndefined(breakpoint.xs) &&
          elWidth >= breakpoint.xs.width
        ) {
          if (elHeight >= breakpoint.xs.height) {
            this.size = 'xs';
          } else {
            this.size = 'xxs';
          }
        } else {
          this.size = 'xxs';
        }
        // sm
        if (isNumber(breakpoint.sm) && elWidth >= breakpoint.sm) {
          this.size = 'sm';
        } else if (
          !isUndefined(breakpoint.sm) &&
          elWidth >= breakpoint.sm.width
        ) {
          if (elHeight >= breakpoint.sm.height) {
            this.size = 'sm';
          } else if (elHeight >= breakpoint.xs.height) {
            this.size = 'xs';
          } else {
            this.size = 'xxs';
          }
        }
        // md
        if (isNumber(breakpoint.md) && elWidth >= breakpoint.md) {
          this.size = 'md';
        } else if (
          !isUndefined(breakpoint.md) &&
          elWidth >= breakpoint.md.width
        ) {
          if (elHeight >= breakpoint.md.height) {
            this.size = 'md';
          } else if (elHeight >= breakpoint.sm.height) {
            this.size = 'sm';
          } else if (elHeight >= breakpoint.xs.height) {
            this.size = 'xs';
          } else {
            this.size = 'xxs';
          }
        }
        // lg
        if (isNumber(breakpoint.lg) && elWidth >= breakpoint.lg) {
          this.size = 'lg';
        } else if (
          !isUndefined(breakpoint.lg) &&
          elWidth >= breakpoint.lg.width
        ) {
          if (elHeight >= breakpoint.lg.height) {
            this.size = 'lg';
          } else if (elHeight >= breakpoint.md.height) {
            this.size = 'md';
          } else if (elHeight >= breakpoint.sm.height) {
            this.size = 'sm';
          } else if (elHeight >= breakpoint.xs.height) {
            this.size = 'xs';
          } else {
            this.size = 'xxs';
          }
        }
        // xl
        if (isNumber(breakpoint.xl) && elWidth >= breakpoint.xl) {
          this.size = 'xl';
        } else if (
          !isUndefined(breakpoint.xl) &&
          elWidth >= breakpoint.xl.width
        ) {
          if (elHeight >= breakpoint.xl.height) {
            this.size = 'xl';
          } else if (elHeight >= breakpoint.lg.height) {
            this.size = 'lg';
          } else if (elHeight >= breakpoint.md.height) {
            this.size = 'md';
          } else if (elHeight >= breakpoint.sm.height) {
            this.size = 'sm';
          } else if (elHeight >= breakpoint.xs.height) {
            this.size = 'xs';
          } else {
            this.size = 'xxs';
          }
        }
        // xxl
        if (isNumber(breakpoint.xxl) && elWidth >= breakpoint.xxl) {
          this.size = 'xxl';
        } else if (
          !isUndefined(breakpoint.xxl) &&
          elWidth >= breakpoint.xxl.width
        ) {
          if (elHeight >= breakpoint.xxl.height) {
            this.size = 'xxl';
          } else if (elHeight >= breakpoint.xl.height) {
            this.size = 'xl';
          } else if (elHeight >= breakpoint.lg.height) {
            this.size = 'lg';
          } else if (elHeight >= breakpoint.md.height) {
            this.size = 'md';
          } else if (elHeight >= breakpoint.sm.height) {
            this.size = 'sm';
          } else if (elHeight >= breakpoint.xs.height) {
            this.size = 'xs';
          } else {
            this.size = 'xxs';
          }
        }
      });
    },
    $getSize() {
      return this.size;
    }
  }
};
</script>
